import { localize, setLocale } from '@vee-validate/i18n';
import ja from '@vee-validate/i18n/dist/locale/ja.json';
import { all } from '@vee-validate/rules';
import { defineRule, configure } from 'vee-validate';

configure({
  generateMessage: localize({
    ja: {
      ...ja,
      messages: {
        ...ja.messages,
        alpha_num: '{_field_}は半角英数字のみ使用できます',
        input_required: '{field}を入力してください',
        input_required_simple: '入力してください',
        select_required: '{field}を選択してください',
        numeric_simple: '数字を入力してください',
        max_simple: '0:{length}文字以内にしてください',
        max_value_simple: '0:{max}以下で入力してください',
        tel: '電話番号が正しくありません',
        email: 'メールアドレスが正しくありません',
        zip: '郵便番号が正しくありません',
        member_name: '使用できないフレーズが含まれています',
        shop_alias: '使用できない文字が含まれています',
        account_number: '半角数字7桁で入力して下さい',
        account_name: '全角カナ・アルファベット・数字で入力して下さい',
        instagram_id: 'ユーザーネームを入力してください',
        facebook_id: 'ユーザーIDを入力してください',
        twitter_id: 'ユーザー名を入力してください',
        tracking_code: '{_field_}は半角英数字のみ使用できます',
      },
    },
  }),
});
setLocale('ja');

export const validateZipcode = (value: string) => !value || /^\d{3}-?\d{4}$/.test(value);

Object.entries(all).forEach(([name, rule]) => {
  defineRule(name, rule);
});
defineRule('input_required', all.required);
defineRule('input_required_simple', all.required);
defineRule('select_required', all.required);
defineRule('max_simple', all.max);
defineRule('max_value_simple', all.max_value);
defineRule('numeric_simple', all.numeric);
defineRule('alpha_num', (value: string) => !value || /^[\dA-Za-z]+$/.test(value));
defineRule('tel', (value: string) => !value || /^0[\d-]{9,}$/.test(value));
defineRule('email', (value: string) => !value || /^[\w+.-]+@((\[(?:\d{1,3}\.){3}\d{1,3}])|(([\dA-Za-z-]+\.)+[A-Za-z]{2,}))$/.test(value));
defineRule('zip', (value: string) => validateZipcode(value));
defineRule('member_name', (value: string) => !/(iichi|ｉｉｃｈｉ|いいち|イイチ|support|ｓｕｐｐｏｒｔ|サポート)/i.test(value));
defineRule('shop_alias', (value: string) => !value || /^[\w-]+$/.test(value));
defineRule('account_number', (value: string) => !value || /^\d{7}$/.test(value));
// eslint-disable-next-line no-irregular-whitespace
defineRule('account_name', (value: string) => !value || /^[\d A-Za-z―　「」ァ-ヶ・ー（），－．／０-９Ａ-Ｚａ-ｚ￥]+$/.test(value));
defineRule('instagram_id', (value: string) => !value || /^[\da-z._]+$/.test(value));
defineRule('facebook_id', (value: string) => !value || /^[\da-zA-Z.]+$/.test(value));
defineRule('twitter_id', (value: string) => !value || /^[\da-zA-Z_]+$/.test(value));
defineRule('tracking_code', (value: string) => !value || /^[\da-zA-Z-]+$/.test(value));
